import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const AssignedOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
      <Path d="M9.3 7.5a2.7 2.7 0 1 1 5.4 0 2.7 2.7 0 0 1-5.4 0ZM12 3.2a4.3 4.3 0 0 0-2.619 7.711c-3.607.777-6.371 3.837-6.371 7.539v.78a.8.8 0 0 0 1.6 0v-.78c0-3.322 2.915-6.13 6.57-6.13h1.66c1.365 0 2.636.395 3.678 1.063a.8.8 0 1 0 .864-1.346 8.323 8.323 0 0 0-2.758-1.13A4.3 4.3 0 0 0 12 3.2ZM20.666 13.785a.8.8 0 0 1 0 1.131l-5.87 5.86a.8.8 0 0 1-1.132 0l-2.33-2.33a.8.8 0 0 1 1.132-1.132l1.764 1.765 5.305-5.295a.8.8 0 0 1 1.131 0Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default AssignedOutlined
